import { createContext, useContext } from "react";
import type { ScheduleHolidays } from "./scheduleHolidays";

const NO_HOLIDAYS: ScheduleHolidays = { holidays: [], holidayOn: () => undefined, isError: false };

// DEFAULT: outside a schedule page (or in a test that renders one grid alone) no day is marked.
export const ScheduleHolidaysContext = createContext<ScheduleHolidays>(NO_HOLIDAYS);

/** The page's holidays, from the nearest `ScheduleHolidaysProvider`. Rows import this file, not the provider, so they never load the request code. */
export const usePageScheduleHolidays = (): ScheduleHolidays => useContext(ScheduleHolidaysContext);
